import { render } from "./HighScores.vue?vue&type=template&id=459079ab"
import script from "./HighScores.vue?vue&type=script&lang=js"
export * from "./HighScores.vue?vue&type=script&lang=js"

import "./HighScores.vue?vue&type=style&index=0&id=459079ab&lang=stylus"

import exportComponent from "/opt/build/repo/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__